import React, { useRef, useEffect } from "react";

export const Chart = ({ scores, ...props }) => {
  const canvasRef = useRef(null);
  const TRANSPARENCY = 0.4;

  const draw = (ctx) => {
    const SCALE = 2.5;
    let x = ctx.canvas.width;
    let y = ctx.canvas.height;

    ctx.clearRect(0, 0, x, y);
    ctx.save();

    ctx.translate(x / 2, y / 2);
    ctx.rotate((-30 * Math.PI) / 180);

    x = x / SCALE;
    y = y / SCALE;

    // Grid hex lines
    for (let a = 0; a < 6; a++) {
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(0, 1 * y);
      ctx.lineTo(0.866 * x, y / 2);
      ctx.stroke();

      ctx.rotate((60 * Math.PI) / 180);

      for (let b = 0.8; b >= 0.2; b -= 0.2) {
        ctx.beginPath();
        ctx.lineTo(0, y * b);
        ctx.lineTo(0.866 * x * b, (y / 2) * b);
        ctx.stroke();
      }
    }

    const titles = [
      "Physical",
      "Emotional",
      "Acceptance",
      "Relationships",
      "Loving-Kindness",
      "Intellectual",
    ];

    ctx.font = "20px Arial";
    ctx.textAlign = "center";

    for (let a = 0; a < 6; a++) {
      ctx.fillStyle = `rgba(116, 225, 180, ${TRANSPARENCY})`;
      const absolute = scores[a] / 5.0;

      ctx.beginPath();
      ctx.moveTo(0, -y * absolute);
      ctx.lineTo(0, 0);
      ctx.lineTo(0.866 * x * absolute, (-y * absolute) / 2);
      ctx.fill();

      ctx.beginPath();
      ctx.moveTo(0, -y * absolute);
      ctx.lineTo(0.866 * x * absolute, (-y * absolute) / 2);
      ctx.stroke();

      ctx.rotate((30 * Math.PI) / 180);

      if (a < 2 || a === 5) {
        ctx.fillStyle = "black";
        ctx.fillText(titles[a], 0, -y);
        ctx.fillText(titles[(a + 3) % 6], 0, y);
      }

      ctx.rotate((30 * Math.PI) / 180);
    }

    ctx.restore();
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    draw(ctx);
  }, [scores]);

  return (
    <canvas
      ref={canvasRef}
      width="400"
      height="400"
      className="starChart"
      {...props}
    />
  );
};
